import { useEffect, useState } from 'preact/hooks';
import { connect } from 'stent/lib/helpers';
export const useMachineState = (machine)=>{
    const [state, setState] = useState(machine.state);
    useEffect(function() {
        return connect().with(machine.name).map(function(m) {
            setState(m.state);
        });
    }, [
        machine.name
    ]);
    return state;
};
